<template>
  <div v-if="indirizzo">
    <stepheader :step="step" />

    <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">

      <div class="row">
        <div class="btn-group mt-2 mb-2" v-if="indirizzi.length > 1">
          <button type="button" class="btn btn-outline-default dropdown-toggle" data-bs-toggle="dropdown"
            aria-expanded="false">
            Seleziona un'indirizzo oppure modifica qui sotto <span class="caret"></span>
          </button>
          <ul class="dropdown-menu" role="menu" style="">

            <li v-for="item in indirizzi">
              <a @click="setIndirizzo(item)">

                <p>{{ item.cognomeNome }}</p>
                <p> {{ item.indirizzo }} {{ item.cap }} {{ item.comune }} {{ item.provincia }}</p>


              </a>


            </li>

          </ul>
        </div>


      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="form-label" for="denominazione">Presso: *</label>

          <input type="text" id="denominazione" v-model="indirizzo.denominazione" class="form-control " />
        </div>
        <div class="col-md-6">
          <label class="form-label" for="denominazione">Nome Citofono:</label>
          <input type="text" id="citofono" v-model="indirizzo.citofono" class="form-control " />
        </div>
        <div v-if="false" class="col-md-6">
          <label class="form-label" for="referente">Referente:</label>
          <input type="text" id="referente" v-model="indirizzo.referente" class="form-control " />
        </div>
        <div class="col-md-6">
          <label class="form-label" for="telefono">Telefono: *</label>
          <!-- <input type="tel" id="telefono"  v-model="indirizzo.telefono" class="form-control "/> -->
          <input class="form-control " type="tel" id="telefono" v-model="indirizzo.telefono" @keypress="isNumber($event)">
        </div>
        <div class="col-md-6">
          <label class="form-label" for="cellulare">Cellulare: *</label>
          <!-- <input type="text" id="cellulare"  v-model="indirizzo.cellulare" class="form-control "/> -->
          <input class="form-control " type="tel" id="cellulare" v-model="indirizzo.cellulare"
            @keypress="isNumber($event)">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="form-label" for="indirizzo">Indirizzo: *</label>
          <input type="text" id="indirizzo" v-model="indirizzo.indirizzo" class="form-control " />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-lg-3 col-xl-3">

          <label for="Indirizzo" class="form-label">Regione</label>
          <v-select :options="regioni" label="nomeRegione" :reduce="x => x.idRegione" v-model="indirizzo.idRegione"
            @input="loadProvince" placeholder="Scegli un regione"></v-select>

        </div>
        <div class="col-md-3 col-lg-3 col-xl-3">

          <label for="Indirizzo" class="form-label">Provincia</label>
          <v-select :options="province" :disabled="province.length == 0" label="nomeProvincia" :reduce="x => x.idProvincia"
            v-model="indirizzo.idProvincia" @input="loadComuni" placeholder="Scegli una provincia"></v-select>

        </div>
        <div class="col-md-3 col-lg-3 col-xl-3">

          <label for="Indirizzo" class="form-label">Comune</label>

          <v-select :options="comuni" :disabled="comuni.length == 0" label="nomeComune" :reduce="x => x.idComune"
            v-model="indirizzo.idComune" @input="loadCap" placeholder="Scegli un comune"></v-select>

        </div>
        <div class="col-md-3 col-lg-3 col-xl-3">

          <label for="Indirizzo" class="form-label">Cap</label>
          <v-select :options="cap" :disabled="cap.length == 0" label="cap" :reduce="x => x.idCap" v-model="indirizzo.idCap"
            placeholder="Scegli un cap"></v-select>

        </div>
      </div>
    </div>
    <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>


</div></template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import vSelect from 'vue-select'
export default {
  name: "indirizzoedit",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      indirizzo:null,
      indirizzi:[],
        regioni: [],
                    province: [],
                    comuni:[],
                    cap:[],
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
     this.indirizzo = this.ticket.logistica.filter(x=>x.tipologia==this.step.categorytype)[0];
      axios.get("persone_spedizione/indirizzi").then((response) => {
                        this.indirizzi = response.data;
                    });
     this.loaddata();
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (!((charCode >= 48 && charCode <= 57) || (charCode >= 43 && charCode <= 46))) {
        evt.preventDefault();
      } else {
        return true;
      } 
    },
    fireaction: function (action, nextstep) {
      switch (action) {
        case "next":
          var regioneSelezionata = this.regioni.filter(x=>x.idRegione == this.indirizzo.idRegione)
          if(regioneSelezionata.length>0){
            this.indirizzo.regione = regioneSelezionata[0].nomeRegione.toString();
            console.log(`regione: ${this.indirizzo.regione}`);
          }

          var comuneselezionato = this.comuni.filter(x => x.idComune == this.indirizzo.idComune)
          if (comuneselezionato.length > 0) {
            this.indirizzo.comune = comuneselezionato[0].nomeComune.toString();
            console.log(`comune: ${this.indirizzo.comune}`);
          }

          var provselezionato = this.province.filter(x => x.idProvincia == this.indirizzo.idProvincia)
          if (provselezionato.length > 0) {
            this.indirizzo.provincia = provselezionato[0].siglaProvincia.toString();
            console.log(`provincia: ${this.indirizzo.provincia}`);
          }

          var capselezionato = this.cap.filter(x => x.idCap == this.indirizzo.idCap)
          if (capselezionato.length > 0) {
            this.indirizzo.cap = capselezionato[0].cap.toString();
            console.log(`cap: ${this.indirizzo.cap}`);
          }

          var validPhoneRegex = /^[0-9]{1,}$/;
          if (
            this.indirizzo.indirizzo == "" ||
            this.indirizzo.comune == "" ||
            this.indirizzo.provincia == "" ||
            this.indirizzo.cap == "" ||
            this.indirizzo.denominazione == "" ||
            (this.indirizzo.telefono == "" && this.indirizzo.cellulare == "")          
          ) {
            swal({
              title: "Errore di compilazione",
              text: "Inserire tutti i dati",
              type: "error",
              showCancelButton: false,
              toast: false,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });

          }
          else {
            if (this.step.categorytype == 'ritiro') {
              var riconsegna = this.ticket.logistica.filter(x => x.tipologia == 'riconsegna')[0];
              if (riconsegna) {
                for(var p in this.indirizzo){
                  if(p == 'tipologia'){continue;}
                  riconsegna[p] = this.indirizzo[p];
                }
              }
            }
            this.$emit("goto", nextstep);

          }
          break;
        default:
          this.$emit("goto", nextstep);
          break;
      }

    },
   loaddata: function () {
    axios.get("regioni/getall" ).then((response) => {
                        this.regioni = response.data.results;
                         this.loadProvince(this.indirizzo.idRegione,true);
                        this.loadComuni(this.indirizzo.idProvincia,true);
                       this.loadCap(this.indirizzo.idComune,true);
                    });

                   
    },
setIndirizzo(tochange){
  this.indirizzo.idCap = tochange.idCap;
  this.indirizzo.idComune = tochange.idComune;
  this.indirizzo.idRegione = tochange.idRegione;
  this.indirizzo.idProvincia = tochange.idProvincia;
 this.indirizzo.referente = this.indirizzo.denominazione = tochange.cognomeNome;
this.indirizzo.indirizzo = tochange.indirizzo;
 this.loadProvince(this.indirizzo.idRegione,true);
                        this.loadComuni(this.indirizzo.idProvincia,true);
                       this.loadCap(this.indirizzo.idComune,true);
},
                loadProvince(idRegione, noreset, sp){
                   if(!noreset){
   
                        this.indirizzo.idProvincia = null;
                        this.indirizzo.idComune = null;
                        this.indirizzo.idCap = null;
                   
                   }
                    axios.get("province/regione/"+idRegione).then((response) => {
                        
                        this.province = response.data;
                        
                       
                    });

                },
         
                loadComuni(idprovincia,noreset, sp){
                    if(!noreset){
                             
                            this.indirizzo.idComune = null;
                            this.indirizzo.idCap = null;
                    }
                    axios.get("comuni/provincia/"+idprovincia).then((response) => {
                       
                        this.comuni = response.data;
                         
                    });

                },
                loadCap(idcomune,noreset,sp){
                    if(!noreset){
                        
                           
                            this.indirizzo.idCap = null;
                       
                   
                    }
                    axios.get("cap/comune/"+idcomune).then((response) => {
                      
                       
                        this.cap = response.data;

                        
                    });

                },
    authenticate:function(nextstep){

    }
  },
};
</script>